import React from "react";
import { useTranslation } from "react-i18next";
import { setUiLanguage } from "../i18n";
import { UI_LANGUAGE_OPTIONS, resolveUiLanguage } from "../i18n/languages";

export default function UiLanguageSelect() {
  const { t, i18n } = useTranslation();
  return (
    <label className="inline-flex items-center gap-2 text-[13px] text-gray-700">
      <span>{t("accountMenu.language")}</span>
      <select
        aria-label={t("accountMenu.language")}
        value={resolveUiLanguage(i18n.resolvedLanguage ?? i18n.language)}
        onChange={event => { void setUiLanguage(event.currentTarget.value); }}
        className="h-9 max-w-full rounded-xl border border-gray-200 bg-white px-2 text-[13px] focus:outline-none focus:ring-2 focus:ring-appleblue/20 focus:border-appleblue/50"
      >
        {UI_LANGUAGE_OPTIONS.map(({ language, nativeLabel }) => (
          <option key={language} value={language}>{nativeLabel}</option>
        ))}
      </select>
    </label>
  );
}
